import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-article]')) return;

  addEventListeners();
  articleCheckLikeBtnState();
  articleReadingTime();
  articleLikesAndShareSticky();
}

function addEventListeners() {
  articleHandleButtonClick();
}

/**
 *
 * Function to manage sticky position of like btn on page load
 */
function articleLikesAndShareSticky() {
  const stickyDiv = $('[data-au-article-actions]');
  const footer = $('[data-au-article-footer]');
  const headerHeight = $('header .n-main-header-responsive') ? $('header .n-main-header-responsive').offsetHeight : 0;

  // JavaScript to dynamically adjust the sidebar position based on scroll
  window.addEventListener('scroll', () => {
    const articleBody = $('[data-au-article-body]');
    var articleBodyTop = articleBody.getBoundingClientRect().top + window.scrollY;
    // Get the current scroll position
    const scrollTop = window.scrollY;

    if (scrollTop + headerHeight > articleBodyTop) {
      stickyDiv.style.position = 'fixed';
      stickyDiv.style.top = `${headerHeight}px`;
    } else {
      stickyDiv.style.position = 'absolute';
      stickyDiv.style.top = `${articleBodyTop}px`;
    }
  });

  // Listen for the scroll event
  window.addEventListener('scroll', () => {
    const footerPosition = footer.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    // If the footer is visible (near the bottom of the page)
    if (footerPosition <= windowHeight) {
      stickyDiv.style.opacity = 0; // Hide the sticky div
    } else {
      stickyDiv.style.opacity = 1; // Show the sticky div
    }
  });
}

/**
 *
 * Function to check if like btn is clicked or not
 */
function articleCheckLikeBtnState() {
  const isClicked = localStorage.getItem('articleLiked');
  const buttons = $$('[data-au-article-like]');

  // If clicked, add the 'clicked' class to all buttons
  if (isClicked === 'true') {
    articleHanldeLikeBtnState(buttons);
  }
}

/**
 *
 * Functions on like btn click
 */
function articleHandleButtonClick() {
  const buttons = $$('[data-au-article-like]');

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const button = e.currentTarget;
      const titleText = button.closest('[data-au-article]').querySelector('[data-au-title]').innerText;
      const clickText = button.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      // datalayer
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickIcono',
        item_id,
      });

      // change like state
      articleHanldeLikeBtnState(buttons);

      // Save the state to localStorage (indicating the buttons were clicked)
      localStorage.setItem('articleLiked', 'true');
    });
  });
}

/**
 *
 * @param likeBtns like buttons
 * Change icon, class to remove pointer events and change text
 */
function articleHanldeLikeBtnState(likeBtns) {
  likeBtns.forEach((btn) => {
    const spanInButton = btn.querySelector('[data-au-icon]');
    const isInFooter = btn.closest('[data-au-article-footer]');

    btn.classList.add('au-article__like-btn--liked');
    spanInButton.classList.add('icon-heart-filled');
    spanInButton.classList.remove('icon-heart');
    if (isInFooter) {
      const footerLikeText = btn
        .closest('[data-au-article-footer]')
        .querySelector('[data-au-article-footer-like-text]');

      footerLikeText.textContent = footerLikeText.dataset.auArticleFooterLikeText;
    }
  });
}

/**
 *
 * Add reading time on article header
 */
function articleReadingTime() {
  const text = $('[data-au-article]').innerText;
  const wpm = 225;
  const words = text.trim().split(/\s+/).length;
  const time = `${Math.ceil(words / wpm)}`;
  $('[data-au-article-time]').innerText = time;
}

export default { init };
